import { FC, Fragment, useContext } from 'react';
import Link from 'next/link';
import { i18n as I18n } from 'utils/i18n';

import { AuthContext } from '../../state/auth';

import FeatureIcon from '../shared/featureIcon';

interface Venue {
  id: number;
  floorplans?: Array<string>;
}

interface Space {
  id: number;
  floor: string;
  floorplan?: string;
}

interface Props {
  venue: Venue;
  space?: Space;
  wrapper?: HTMLElement | FC;
}

const FloorplansButton = ({
  venue,
  space,
  wrapper: Wrapper = Fragment,
}: Props) => {
  const { loggedIn, accountApproved } = useContext(AuthContext);

  const userIsApproved = loggedIn && accountApproved;

  const floorplan = space
    ? !!space.floorplan
    : venue.floorplans && !!venue.floorplans.length;

  const location = space
    ? `/properties/${venue.id}/floorplans?spaceId=${space.id}`
    : `/properties/${venue.id}/floorplans`;

  return userIsApproved && floorplan ? (
    <Wrapper>
      <Link href={location}>
        <a data-testid="floorPlansLink" className="venue__floorplans">
          <FeatureIcon
            type="floorplan"
            name={I18n.t('feature_icon.view_floorplan')}
            displaySvgIcon
          />
        </a>
      </Link>
    </Wrapper>
  ) : null;
};

export default FloorplansButton;
